import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { OrderFlowAuthService } from './order-flow-auth.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'of-logout',
  imports: [],
  template: ``
})
export class LogoutComponent implements OnInit {
  private authService = inject(OrderFlowAuthService);

  public ngOnInit(): void {
    // logoutRedirect() navigates to AAD immediately — the observable never completes
    // in the current page context, so there is no success callback to wire up.
    this.authService.logout$().subscribe();
  }
}
